/**
 * Hand the browser a file we generated in memory.
 *
 * The anchor has to be in the document for Firefox to honour a synthetic click,
 * and the object URL has to outlive that click — revoking it in the same tick
 * cancels the download it just started. Hence the append/remove and the deferred
 * revoke; neither is decoration.
 */
export function saveFile(filename: string, body: string, type: string): void {
  const url = URL.createObjectURL(new Blob([body], { type }))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'

  document.body.appendChild(a)
  a.click()
  a.remove()

  setTimeout(() => URL.revokeObjectURL(url))
}
